export default __webpack_public_path__ + "static/media/404.ec84fa54.png";